module.exports = __webpack_public_path__ + "static/media/ai-girl.406a9029.jpg";